import NaCommonKeys from 'src/constants/locale/key/NaCommonKeys'
import Namespace from 'src/constants/locale/Namespace'
import { useTranslation } from 'cng-web-lib'

const NaCommonTranslationText = () => {

  const { translate } = useTranslation([
    Namespace.NA_COMMON
  ])

  let pendingAutoSend = translate(Namespace.NA_COMMON,NaCommonKeys.PENDING_AUTO_SEND)
  let cbsaReceivedAndProcessing = translate(Namespace.NA_COMMON,NaCommonKeys.CBSA_RECEIVEDAND_PROCESSING)
  let registered = translate(Namespace.NA_COMMON,NaCommonKeys.REGISTERED)
  let pending = translate(Namespace.NA_COMMON,NaCommonKeys.PENDING)
  let sendSuccessfully = translate(Namespace.NA_COMMON,NaCommonKeys.SEND_SUCCESSFULLY)
  let rejectType = translate(Namespace.NA_COMMON,NaCommonKeys.REJECT_TYPE)
  let functionalAcnkowledgementMessageReceived = translate(Namespace.NA_COMMON,NaCommonKeys.FUNCTIONAL_ACNKOWLEDGEMENT_MESSAGE_RECEIVED)
  let administrationError = translate(Namespace.NA_COMMON,NaCommonKeys.ADMINISTRATION_ERROR)
  let enforcementError = translate(Namespace.NA_COMMON,NaCommonKeys.ENFORCEMENT_ERROR)
  let syntaxError = translate(Namespace.NA_COMMON,NaCommonKeys.SYNTAX_ERROR)
  let riskAssessment = translate(Namespace.NA_COMMON,NaCommonKeys.RISK_ASSESSMENT)
  let batchError = translate(Namespace.NA_COMMON,NaCommonKeys.BATCH_ERROR)
  let dataError = translate(Namespace.NA_COMMON,NaCommonKeys.DATA_ERROR)
  let supplementaryMatchYes = translate(Namespace.NA_COMMON,NaCommonKeys.SUPPLEMENTARY_MATCH_YES)
  let supplementaryMatchNo = translate(Namespace.NA_COMMON,NaCommonKeys.SUPPLEMENTARY_MATCH_NO)
  let conveyanceArrived = translate(Namespace.NA_COMMON,NaCommonKeys.CONVEYANCE_ARRIVED)
  let accepted = translate(Namespace.NA_COMMON,NaCommonKeys.ACCEPTED)
  let acceptedMatched = translate(Namespace.NA_COMMON,NaCommonKeys.ACCEPTED_MATCHED)
  let manifestForward = translate(Namespace.NA_COMMON,NaCommonKeys.MANIFEST_FORWARD)
  let rejected = translate(Namespace.NA_COMMON,NaCommonKeys.REJECTED)
  let template = translate(Namespace.NA_COMMON,NaCommonKeys.TEMPLATE)
  let cancellationAccepted = translate(Namespace.NA_COMMON,NaCommonKeys.CANCELLATION_ACCEPTED)
  let cancellationRejected = translate(Namespace.NA_COMMON,NaCommonKeys.CANCELLATION_REJECTED)
  let draft = translate(Namespace.NA_COMMON,NaCommonKeys.DRAFT)
  let sn = translate(Namespace.NA_COMMON,NaCommonKeys.SN)
  let snTruckArrived = translate(Namespace.NA_COMMON,NaCommonKeys.SN_TRUCK_ARRIVED)
  let snGoodsRelease = translate(Namespace.NA_COMMON,NaCommonKeys.SN_GOODS_RELEASE)
  let modificationRejected = translate(Namespace.NA_COMMON,NaCommonKeys.MODIFICATION_REJECTED)
  let sent = translate(Namespace.NA_COMMON,NaCommonKeys.SENT)
  let preliminary = translate(Namespace.NA_COMMON,NaCommonKeys.PRELIMINARY) 
  let cp = translate(Namespace.NA_COMMON,NaCommonKeys.CP) 
  let cancel = translate(Namespace.NA_COMMON,NaCommonKeys.CANCEL) 
  let replace = translate(Namespace.NA_COMMON,NaCommonKeys.REPLACE) 
  let confirm = translate(Namespace.NA_COMMON,NaCommonKeys.CONFIRM) 
  let spl = translate(Namespace.NA_COMMON,NaCommonKeys.SPL) 
  let acceptedWithWarning = translate(Namespace.NA_COMMON,NaCommonKeys.ACCEPTED_WITH_WARNING) 
  let sendFailed = translate(Namespace.NA_COMMON,NaCommonKeys.SEND_FAILED) 
  let pendingReview = translate(Namespace.NA_COMMON,NaCommonKeys.PENDING_REVIEW) 
  let reviewInProgress = translate(Namespace.NA_COMMON,NaCommonKeys.REVIEW_IN_PROGRESS) 
  let reviewed = translate(Namespace.NA_COMMON,NaCommonKeys.REVIEWED) 
  let userPasswordExpiredMsg = translate(Namespace.NA_COMMON,NaCommonKeys.USER_PASSWORD_EXPIRED_MSG)
  let updatePassword = translate(Namespace.NA_COMMON,NaCommonKeys.UPDATE_PASSWORD) 

  let add = translate(Namespace.NA_COMMON, NaCommonKeys.ADD)
  let addNew = translate(Namespace.NA_COMMON, NaCommonKeys.ADD_NEW)
  let removeButton = translate(Namespace.NA_COMMON, NaCommonKeys.REMOVE_BUTTON)
  let mandatoryFields = translate(Namespace.NA_COMMON, NaCommonKeys.MANDATORY_FIELDS)
  let noRecordsMessage = translate(Namespace.NA_COMMON, NaCommonKeys.NO_RECORDS_MESSAGE)
  let ok = translate(Namespace.NA_COMMON, NaCommonKeys.OK)
  let action = translate(Namespace.NA_COMMON, NaCommonKeys.ACTION)
  let accountNameAndOr = translate(Namespace.NA_COMMON, NaCommonKeys.ACCOUNT_NAME_AND_OR)
  let history = translate(Namespace.NA_COMMON, NaCommonKeys.HISTORY)
  let confirmationMessage = translate(Namespace.NA_COMMON, NaCommonKeys.CONFIRMATION_MESSAGE)
  let confirmDiscard = translate(Namespace.NA_COMMON, NaCommonKeys.CONFIRM_DISCARD)
  let continueEdit = translate(Namespace.NA_COMMON, NaCommonKeys.CONTINUE_EDIT)
  let dataNotFound = translate(Namespace.NA_COMMON, NaCommonKeys.DATA_NOT_FOUND)
  let saveChanges = translate(Namespace.NA_COMMON, NaCommonKeys.SAVE_CHANGES)
  let reset = translate(Namespace.NA_COMMON, NaCommonKeys.RESET)
  let submit = translate(Namespace.NA_COMMON, NaCommonKeys.SUBMIT)
  let download = translate(Namespace.NA_COMMON, NaCommonKeys.DOWNLOAD)
  let save = translate(Namespace.NA_COMMON, NaCommonKeys.SAVE)
  let discard = translate(Namespace.NA_COMMON, NaCommonKeys.DISCARD)
  let saveAsDraft = translate(Namespace.NA_COMMON, NaCommonKeys.SAVE_AS_DRAFT)
  let update = translate(Namespace.NA_COMMON, NaCommonKeys.UPDATE)
  let editButton = translate(Namespace.NA_COMMON, NaCommonKeys.EDIT)
  let deleteButton = translate(Namespace.NA_COMMON, NaCommonKeys.DELETE)
  let deleteConfirmationMsg = translate(Namespace.NA_COMMON, NaCommonKeys.DELETE_CONFIRMATION_MSG)
  let deleteConfirmButton = translate(Namespace.NA_COMMON, NaCommonKeys.DELETE_CONFIRM_BUTTON)
  let deleteCancelButton = translate(Namespace.NA_COMMON, NaCommonKeys.DELETE_CANCEL_BUTTON)
  let deactivated = translate(Namespace.NA_COMMON, NaCommonKeys.DEACTIVATED)
  return {
    pendingAutoSend,
    cbsaReceivedAndProcessing,
    registered,
    pending,
    sendSuccessfully,
    rejectType,
    functionalAcnkowledgementMessageReceived,
    administrationError,
    enforcementError,
    syntaxError,
    riskAssessment,
    batchError,
    dataError,
    supplementaryMatchYes,
    supplementaryMatchNo,
    conveyanceArrived,
    accepted,
    acceptedMatched,
    manifestForward,
    rejected,
    template,
    cancellationAccepted,
    cancellationRejected,
    draft,
    sn,
    snTruckArrived,
    snGoodsRelease,
    modificationRejected,
    sent,
    preliminary,
    cp,
    cancel,
    replace,
    confirm,
    spl,
    acceptedWithWarning,
    sendFailed,
    pendingReview,
    reviewInProgress,
    reviewed,
    userPasswordExpiredMsg,
    updatePassword,
    add,
    addNew,
    removeButton,
    mandatoryFields,
    noRecordsMessage,
    ok,
    action,
    accountNameAndOr,
    history,
    confirmationMessage,
    confirmDiscard,
    continueEdit,
    dataNotFound,
    saveChanges,
    reset,
    submit, 
    download,
    save,
    discard,
    saveAsDraft,
    update,
    editButton,
    deleteButton,
    deleteConfirmationMsg,
    deleteConfirmButton,
    deleteCancelButton,
    deactivated
  }
}

export default NaCommonTranslationText